import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EButtonType = {
	submit: 'submit',
	button: 'button',
	reset: 'reset',
} as const;

export type TButtonType = TValueOfStringRecord<typeof EButtonType>
